import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { AccountMenu, Button, ButtonVariant, IconName, IconColor, IconSize, Popover, PopoverSize, } from '@as/cotopaxi';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
export const AccountMenuPopover = ({ items, logout, anchorEl, onClose, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const accountMenuTranslations = {
        logout: t(`${I18N_NAMESPACES.account}:account.logout`),
    };
    const mappedItems = items ? items.map(item => ({ href: item.link, label: item.label })) : [];
    const isDesktop = useMediaQueryMatchesOnDesktop();
    return (_jsx(Popover, { dataQA: "account_popover", anchorEl: anchorEl, hasScrollLock: !isDesktop, onClose: onClose, title: t('account.account.popover'), rightElement: _jsx(Button, { variant: ButtonVariant.TRANSPARENT, onClick: onClose, icon: {
                name: IconName.CLOSE,
                color: IconColor.ACTION,
                size: IconSize.MAJOR,
            } }), size: PopoverSize.MEDIUM, showTitleOnDesktop: true, children: _jsx("div", { "data-analytics-bannerid": "header-account-flyout", children: _jsx(AccountMenu, { items: mappedItems, onLogout: logout, translations: accountMenuTranslations }) }) }));
};
